export default __webpack_public_path__ + "static/media/tres_avatares.e1d0a427.svg";